export default __webpack_public_path__ + "static/media/ic-digital-library.c1fda4d9.svg";